<template>
	<div class="results-list">
		<SearchResultsFilter :resCount="results.length" />
		<SearchResultsCard
			v-for="res in filteredResults"
			:result="res"
			:key="res.id"
			:searchString="searchString"
		/>
		<!-- pagination here -->
	</div>
</template>

<script>
import SearchResultsCard from "./SearchResultsCard";
import SearchResultsFilter from "./SearchResultsFilter";

export default {
	name: "SearchResultsList",
	components: {
		SearchResultsCard,
		SearchResultsFilter,
	},
	props: ["results", "searchString"],
	mounted() {
		this.filterResults();
	},
	data: function () {
		return {
			filteredResults: [],
		};
	},
	methods: {
		filterResults: function () {
			let type = this.$route.query.filterType;
			if (!type || type == "All") {
				this.filteredResults = this.results;
				return;
			}
			this.filteredResults = this.results.filter(
				(r) => r.articleType == type
			);
		},
	},
	watch: {
		"$route.query.filterType": "filterResults",
		results: "filterResults",
	},
};
</script>

<style>

</style>